import { useEffect, useState } from "react";
import dailyFilterDefault from '@/pages/dashboard/filterPageComponents/overview/dailyFilterDefault';
import { formatFilterValues, formatSingleTime } from '@/pages/dashboard/utils/utils';
import { overviewMonthlyRequest } from "../../pages/overview/_config/overviewMonthlyRequest";
import { getDefaultUtcDateValue } from "../../utils/dateUtils";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns 
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useMonthlyKeyMetricsTrendModel = (
  props: any, 
  formValue: any, 
  dispatch: any, 
  filterLoading: boolean, 
  dateDimension = 'DAY',
  overviewMonthlyReqType: string = 'normal'
) => {
  const { gameCode, } = props;
  const formVal = formValue || dailyFilterDefault;
  const [componentData, setComponentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // 点击筛选器的时候
  useEffect(() => {
    if (!formValue) return;
    if (!filterLoading) {
      getWeeklyKeyMetricsTrendDataFunc();
    }
  }, [formVal]);


  const getWeeklyKeyMetricsTrendDataFunc = (isRefresh?: boolean) => {

    const {  filterValue, diff, timeType } = formVal;
    const metrics = ['mau', 'revenue', 'new', 'm2', 'arpu', 'payer_ratio'];
    // markets筛选器不存在的时候不传markets，存在的时候传[]
    // 非继承，第一次进入页面折线图区14天、6周、6月
    const { rangeTime, ...filters } = filterValue;
    const defaultTimeRange = getDefaultUtcDateValue(dateDimension, rangeTime);
    const rangeTimeArr = diff ?  defaultTimeRange : formatSingleTime(rangeTime, timeType);
    const [start, end] = rangeTimeArr;
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: start,
      end_time: end,
      metrics,
    };

    setLoading(!isRefresh);
    overviewMonthlyRequest.loadMonthlyMetricsTrend[overviewMonthlyReqType](params).then((result: any) => {
      setError(false);
      setLoading(false);
      setComponentData(result);
      dispatch({
        type: "overview/loadMonthlyMetricsTrend",
        payload: {
          result
        }
      });
    }).catch(() => {
      setError(true);
      setLoading(false);
    });
  };
  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useMonthlyKeyMetricsTrendModel;